import axios from "axios";
import Swal from "sweetalert2";
import { getEffectiveTypeParameterDeclarations } from "typescript";
import { ACTIONS } from "../redux/actions";
import { requestType } from "../types";
import alert, { Redirect } from "./alert";
import routes from "./routes";
const urls: { [key: string]: any } = {};
const { REACT_APP_JOBS_BACKEND_URL = routes.baseURL } = process.env;
const instance = axios.create({})


export default async function request({ url = '', method = 'POST', data = {}, options = {}, dispatch = null, useBaseUrl = true, useAlert = false, navigate, params = {}, location, useLoader = true }: requestType) {
  try {

    if (urls[url]) {
      return
    }

    if (!dispatch) {
      return
    }

    const moreOptions: any = {
      ...options
    }

    if (useBaseUrl) {
      moreOptions.withCredentials = true
      moreOptions.baseURL = REACT_APP_JOBS_BACKEND_URL;
      moreOptions.credentials = 'include';
      moreOptions.headers = {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
        ...(moreOptions.headers||{})
      }
    }
    urls[url] = url;

    useLoader && dispatch({ type: ACTIONS.LOADING, loading: useLoader });

    const result = await instance.request({
      ...moreOptions,
      url,
      method,
      params,
      data
    })
    delete urls[url];
    if (!Object.keys(urls).length && dispatch) {
      dispatch({ type: ACTIONS.LOADING, loading: false })
    }
    useAlert && alert({
      icon: "success",
      title: "Message",
      text: result?.data?.message || "Successful"
    })
    return result.data;
  } catch (e: any) {
    delete urls[url];
    if (!Object.keys(urls).length && dispatch) {
      dispatch({ type: ACTIONS.LOADING, loading: false })
    }
    const error = e?.response?.data;
    const message = error?.message || e.message
    if ([403, 401].includes(error?.statusCode)) {
      dispatch && dispatch({ type: ACTIONS["USERINFO"], userInfo: {} })
      if (!navigate) {
        return error;
      } else {
        return Redirect({ navigate, location, goBack: true })
      }

    }
    alert({
      icon: "error",
      title: "Oops",
      text: message
    })

    console.log(error)
    return error;
  }

}